import React, { MutableRefObject } from "react";
import { getThemeType } from '../../helpers/session';
//import { saveAs } from 'file-saver';
import iconvLite from 'iconv-lite'

import ReactDataGrid from '@inovua/reactdatagrid-community'
import '@inovua/reactdatagrid-community/base.css'
import '@inovua/reactdatagrid-community/theme/blue-dark.css'
import { TypeComputedProps, TypeDataGridProps, TypeRowProps } from "@inovua/reactdatagrid-community/types";

var timerId: any = null;

interface StyledReactDataGridProps {
    onDoubleRowClick?: (rowProps: TypeRowProps, event: MouseEvent) => void;
}

const StyledReactDataGrid = (props: TypeDataGridProps | StyledReactDataGridProps | any) => {
    let { onRowClick, onDoubleRowClick, ...other } = props;

    const handleRowClick = (rowProps: TypeRowProps, event: MouseEvent) => {
        if (onDoubleRowClick) {

            if (!timerId) {
                timerId = setTimeout(() => {
                    if (onRowClick)
                        onRowClick(rowProps, event);
                    timerId = null;
                }, 300);
            }
            else {
                timerId = clearTimeout(timerId);
                onDoubleRowClick(rowProps, event);
            }

        } else if (onRowClick)
            onRowClick(rowProps, event);
    }

    const scrollProps = Object.assign({}, ReactDataGrid.defaultProps.scrollProps, {
        autoHide: false,
        alwaysShowTrack: true
    })

    return (
        <ReactDataGrid
            theme={'blue-dark'}
            onRowClick={handleRowClick}
            scrollProps={scrollProps}
            {...other} />
    );
}

const SEPARATOR = ';';
export const handleExportToCsv = (gridRef: MutableRefObject<TypeComputedProps> | null, defaultFilename: string | null) => {
    if (gridRef?.current) {
        const columns = gridRef.current.visibleColumns;

        const header = columns.map((c) => c.name).join(SEPARATOR);
        const rows = gridRef.current.data.map((data) => columns.map(
            (c) => {
                if (c.render)
                    return c.render({ data, value: data[c.id] })
                else
                    return data[c.id];
            }

        ).join(SEPARATOR));

        const contents = [header].concat(rows).join('\n');
        const blob = new Blob([iconvLite.encode(contents, 'latin1')], { type: 'text/csv;charset=windows-1252;' });

        //saveAs(blob, defaultFilename ? defaultFilename : 'export.csv');
    }
};

export default StyledReactDataGrid;